import { render } from "./PetitieModule.vue?vue&type=template&id=50eaaca2"
import script from "./PetitieModule.vue?vue&type=script&lang=js"
export * from "./PetitieModule.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/.pnpm/vue-loader@17.0.1_ceoavo7i67lvjzxxtqa4yhrx7m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__